import React from 'react';
import { Typography } from '@mui/material';

import { displayClientName } from './Utils';

function ClientContact ({client}) {
    return (
        <>
            { client ? 
            <>
                <Typography variant='subtitle1' gutterBottom>
                    Name: {displayClientName(client)}
                </Typography>
                <Typography variant='subtitle1' gutterBottom>
                    Email: {client?.email}
                </Typography>
                <Typography variant='subtitle1' gutterBottom>
                    Phone: {client?.userprofile?.phone}
                </Typography>
                <Typography variant='subtitle1' gutterBottom>
                    Country: {client?.userprofile?.country?.name}
                </Typography>
            </>
        : null}
        </>
    )
}

export default ClientContact;